import { render, staticRenderFns } from "./investments.vue?vue&type=template&id=292ffae9"
import script from "./investments.vue?vue&type=script&lang=js"
export * from "./investments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports